import type { ProductResource } from "../../product";

export enum ProductGroupIncludes {
  Ancestors = "ancestors",
  Descendants = "descendants",
}

export enum ProductGroupFilters {
  DeepTitle = "deep_title",
  ParentId = "parent_id",
}

export interface ProductGroupResource {
  id: string;
  gid: string;
  title: string;
  description: string | null;
  is_blocked: boolean;
  path: {
    id: string;
    title: string;
  }[];
  has_children: boolean;
  parent: ProductGroupResource | null;
  children?: string;
  ancestors?: number;
  descendants?: string;
  products?: ProductResource[];
  is_excluded?: string;

  //includes
  productsCount?: number;
  productsExists?: string;
  childrenCount?: number;
  childrenExists?: string;
  parentCount?: string;
  parentExists?: string;
  ancestorsCount?: number;
  ancestorsExists?: string;
  descendantsCount?: number;
  descendantsExists?: string;
}

export type UpdateProductGroupRequestBody = {
  title: string;
  parent_id?: string | null;
};

export type StoreProductGroupRequestBody = {
  title: string;
  parent_id?: string | null;
};
